"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryFile = exports.writeBinaryPropertiesMeta = exports.readBinaryPropertiesMeta = void 0;
const validator_1 = require("@leavy/validator");
const BINARY_PROPS_META_SYM = Symbol.for("@leavy/cq/BINARY_PROPERTIES_META");
function readBinaryPropertiesMeta(target) {
    var _a;
    return (_a = target[BINARY_PROPS_META_SYM]) !== null && _a !== void 0 ? _a : null;
}
exports.readBinaryPropertiesMeta = readBinaryPropertiesMeta;
function writeBinaryPropertiesMeta(target, meta) {
    target[BINARY_PROPS_META_SYM] = meta;
}
exports.writeBinaryPropertiesMeta = writeBinaryPropertiesMeta;
/**
 * Flag binary files properties. Must be put on every invocation binary properties
 * @returns {<T extends object, Key extends keyof T, Res=T[Key] extends object ? any : unknown>(target: T, property: Key) => Res}
 * @constructor
 */
function BinaryFile() {
    return (target, property) => {
        let meta = readBinaryPropertiesMeta(target.constructor);
        if (!meta) {
            meta = {
                properties: new Set(),
            };
            writeBinaryPropertiesMeta(target.constructor, meta);
        }
        // True when metadata are inherited
        else if (!target.hasOwnProperty(BINARY_PROPS_META_SYM)) {
            writeBinaryPropertiesMeta(target.constructor, {
                properties: new Set(meta.properties),
            });
        }
        // apply the @Ignore decorator on the property
        validator_1.Ignore()(target, property);
        meta.properties.add(property);
    };
}
exports.BinaryFile = BinaryFile;
//# sourceMappingURL=BinaryFileDecorator.js.map